(function () {

  'use strict';

  function pxAddPrinter(
    SnmpConfigurationService, PrinterListService, toastr, WorkstationListPaging, WorkstationListService, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/addPrinter/addPrinter.template.html',
      link: function (scope) {

        scope.networkId = getIdFromLinksSelfHref(scope.context);

        scope.printer = {
          ipAddress: null,
          type: 'NETWORK',
          networkId: scope.context._links.self.href
        };

        (function () {
          getDefaultSnmpConfiguration();
          getWorkstations();
        })();

        function getIdFromLinksSelfHref(object) {
          return object._links.self.href.slice(-36);
        }

        function getDefaultSnmpConfiguration() {
          SnmpConfigurationService.getDefaultSnmpConfiguration().then(function (defaultSnmpConfiguration) {
            scope.selectedSnmpConfig = defaultSnmpConfiguration;
          }).catch(function(error){});
        }

        function getWorkstations() {
          const paginationObject = new WorkstationListPaging();
          paginationObject.pagingCriteria.networks = scope.context._links.self.href;
          paginationObject.pagingCriteria.pageSize = 1;
          paginationObject.pagingCriteria.active = true;
          WorkstationListService.getWorkstationListPaged(paginationObject).then(function (workstations) {
            scope.workstationsLoaded = true;
            scope.workstationsOnline = workstations.page.totalElements > 0;
          }).catch(function(error){});
        }

        scope.showSnmpList = function () {
          scope.snmpConfigurationSelectorIsOpen = true;
        };

        scope.selectSnmpConfig = function (snmpConfig) {
          scope.snmpConfigurationSelectorIsOpen = false;
          if (snmpConfig) {
            scope.selectedSnmpConfig = snmpConfig;
          }
        };

        scope.addPrinter = function () {
          scope.printer.snmpConfiguration = scope.selectedSnmpConfig.info._links.self.href;
          PrinterListService.createPrinter(scope.printer).then(function () {
            toastr.success($filter('translate')('WorkingOnIt'));
          }).catch(function(error){});
          scope.callback();
        };

        // TOOLTIP STUFF
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          const offsetLeft = angular.element('.context-content-container')[0].offsetLeft;
          const offsetTop = angular.element('.context-content-container')[0].offsetTop;
          if (showTip) {
            position.startX = position.startX - offsetLeft;
            position.startY = position.startY - offsetTop;
            switch (tooltipScope) {
              case 'snmpTooltip':
                snmpTooltip(position, context);
                break;
            }
          } else {
            scope.clearTooltip();
          }
        };

        function snmpTooltip(position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: context.info.name,
            type: 'snmpDescription',
            icon: 'icon-connection',
            snmpConfiguration: context
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 },
            contextMenu: true
          };
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        };

      }
    };
  }

  pxAddPrinter.$inject = ['SnmpConfigurationService', 'PrinterListService', 'toastr', 'WorkstationListPaging', 'WorkstationListService', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxAddPrinter', pxAddPrinter);

})();
